const TCOConfig = {
  collection: "tco",
  fields: [
    "id",
    "variables",
    "formula",

    "display_style",
    "highlight_condition",
    "highlight_condition_value"
  ],

  adapter: class TCO {
    constructor(tco) {
      this.id = tco.id;
      this.variables = tco.variables;
      this.formula = tco.formula;
      this.display_style = tco.display_style;
      this.highlight_condition = tco.highlight_condition;
      this.highlight_condition_value = tco.highlight_condition_value;
    }

    map(collections, maps) {
      this.display_style =
        maps.attribute_styles?.[this.display_style] ||
        maps.specification_styles?.[this.display_style];
    }
  }
};

export default TCOConfig;
